const OWN = {
  Chart_V5: () => import('@/components/widgetcomponents/Viz_Elements/Chart_V5.vue'),
  Chart_V6: () => import('@/components/widgetcomponents/Viz_Elements/Chart_V6.vue'),
  Pie_Chart: () => import('@/components/widgetcomponents/Viz_Elements/Pie_Chart.vue'),
  HexMap: () => import('@/components/widgetcomponents/Viz_Elements/HexMap.vue'),
  Sankey_Diagram: () => import('@/components/widgetcomponents/Viz_Elements/Sankey_Diagram.vue'),
  InsightViz: () => import('./InsightViz.vue'),
  ComposableAlertDetail: () => import('@/components/InsightsNew/ComposableAlertDetail.vue'),
  Worklist_FilterBar: () => import('@/components/widgetcomponents/Worklist_FilterBar.vue'),
  LoadingIndicator: () => import('@/components/widgetcomponents/library/LoadingIndicator.vue'),
  ExportMenu: () => import('@/components/widgetcomponents/library/ExportMenu.vue'),
  MultiSelectDropdown: () => import('@/components/widgetcomponents/library/MultiSelectDropdown.vue'),
  Tag: () => import('@/components/widgetcomponents/library/Tag.vue'),
};

const cache = {};

export function mountableNames() {
  return Object.keys(OWN);
}

export async function loadMountable(name) {
  if (cache[name]) return cache[name];
  let component = null;
  if (OWN[name]) {
    component = (await OWN[name]()).default;
  } else {
    const { getComponent } = await import('@/config/configurableComponentRegistry');
    component = getComponent(name);
  }
  if (component) cache[name] = component;
  return component;
}
